import React from "react";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { BrowserRouter, Link, Route, Switch, useRouteMatch } from "react-router-dom";
import Button from "devextreme-react/button";
import { Requests } from "components/Requests";
import { Deliveries } from "components/Deliveries";
import { routes } from "routes";
import { systemService } from "api/SystemService";
import { TestMessage } from "components/TestMessage";
import { Binding } from "components/Binding";
import { User } from "api/User";
import { roles } from "api/security";

export function Main(props: { user?: User; onLogout: () => void }) {
    if (!props.user || !props.user.roles) {
        return null;
    }
    return (
        <div style={{ padding: 8 }}>
            <BrowserRouter>
                <Toolbar>
                    <Item location="before" component={Caption} />
                    <Item location="before" widget="dxButton" render={() => <RequestsButton />} />
                    <Item location="before" widget="dxButton" render={() => <StatisticButton />} />
                    <Item location="before" widget="dxButton" render={() => <TestMessageButton />} />
                    <Item location="before" widget="dxButton" render={() => <BindingsButton />} />
                    <Item location="after" text={props.user?.name} />
                    <Item location="after" render={() => <LogoutButton onClick={props.onLogout} />} />
                </Toolbar>
                <hr />

                {props.user.roles.includes(roles.MessengerAdmin) ? (
                    <Switch>
                        <Route exact path="/"></Route>
                        <Route exact path={routes.requests}>
                            <Requests />
                        </Route>
                        <Route exact path={routes.statistic}>
                            <Deliveries />
                        </Route>
                        <Route exact path={routes.testMessage}>
                            <TestMessage />
                        </Route>
                        <Route exact path={routes.bindings}>
                            <Binding />
                        </Route>
                    </Switch>
                ) : (
                    <h3>Access denied</h3>
                )}
            </BrowserRouter>
        </div>
    );
}

function Caption() {
    const [version, setVersion] = React.useState<string>();
    React.useEffect(() => {
        systemService.Version().then((v) => setVersion(v));
    }, []);
    return (
        <div className="toolbar-label" style={{ marginRight: 12, marginLeft: 12 }}>
            <b>DPA Messenger</b>&nbsp;v.{version}
        </div>
    );
}

function RequestsButton() {
    return <RouteButton route={routes.requests} text="DPA Instance requests" />;
}

function StatisticButton() {
    return <RouteButton route={routes.statistic} text="Message statistic" />;
}

function TestMessageButton() {
    return <RouteButton route={routes.testMessage} text="Test message" />;
}

function BindingsButton() {
    return <RouteButton route={routes.bindings} text="Telegram bindings" />;
}

function RouteButton(props: { route: string; text: string }) {
    const match = useRouteMatch(props.route);
    return (
        <Link to={props.route}>
            <Button text={props.text} stylingMode={match?.isExact ? "contained" : "text"} type="default" />
        </Link>
    );
}

function LogoutButton(props: { onClick: () => void }) {
    return (
        <Button
            stylingMode="text"
            icon="user"
            text="Logout"
            onClick={props.onClick /*() => accountService.Logout().then(() => document.location.reload())*/}
        ></Button>
    );
}
